import layoutWrapper from "./LayoutWrapper";
import TableRows from "./TableWrapper";

const ReusableComponent = layoutWrapper(TableRows);

export default ReusableComponent;
